import React, { useMemo } from 'react';
import { FiStar, FiTag } from 'react-icons/fi';
import Tooltip from '../../layout/ReusableComponent/Tooltip/Tooltip';
import {
  colorTagHex,
  itemHasMeta,
  itemMetaSummaryParts,
} from '../utils/itemMetaDisplay';

function metaItemForDisplay(item, inFavoritesView) {
  if (inFavoritesView && item && !item.isFavorite) {
    return { ...item, isFavorite: true };
  }
  return item;
}

function MetaTooltipContent({ parts }) {
  if (!parts.length) return null;
  return (
    <ul className="sb-meta-tooltip-list">
      {parts.map((line) => (
        <li key={line}>{line}</li>
      ))}
    </ul>
  );
}

function stopBubble(e) {
  e.stopPropagation();
}

/**
 * Favourite, tag colour, and label indicators.
 * @param {'list' | 'grid' | 'tree'} variant
 */
export default function StorageBoxItemMetaBadge({ item, inFavoritesView = false, variant = 'list' }) {
  const displayItem = metaItemForDisplay(item, inFavoritesView);
  const parts = useMemo(() => itemMetaSummaryParts(displayItem), [displayItem]);

  if (!item || !itemHasMeta(displayItem)) return null;

  const ariaLabel = parts.join(', ');
  const hex = displayItem.colorTag ? colorTagHex(displayItem.colorTag) : null;
  const showFavorite = Boolean(displayItem.isFavorite);
  const showColor = Boolean(displayItem.colorTag);
  const showLabel = Boolean(displayItem.tagLabel);

  const icons = (
    <span
      className={`sb-meta-icons sb-meta-icons--${variant}`}
      aria-label={ariaLabel}
      role="img"
      onClick={stopBubble}
      onPointerDown={stopBubble}
    >
      {showFavorite ? (
        <FiStar className="sb-meta-icons__star" fill="currentColor" aria-hidden />
      ) : null}
      {showColor ? (
        <span
          className="sb-meta-icons__color"
          style={hex ? { backgroundColor: hex } : undefined}
          aria-hidden
        />
      ) : null}
      {showLabel ? <FiTag className="sb-meta-icons__tag" aria-hidden /> : null}
    </span>
  );

  return (
    <Tooltip
      text={<MetaTooltipContent parts={parts} />}
      position={variant === 'grid' || variant === 'tree' ? 'top' : 'left'}
      className={`sb-meta-icons-tooltip-wrap sb-meta-icons-tooltip-wrap--${variant}`}
      hideOnPress
    >
      {icons}
    </Tooltip>
  );
}
